import React, { useState, useEffect, useMemo } from 'react';
import { string } from 'prop-types';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import { v4 } from 'uuid';
import {
  Container,
  ContainerDropwdown,
  ContainerHeader,
  ContainerPath,
  Divider,
  Dropdown,
  Header,
  Text,
  Message,
  Loader,
} from './styles';

import BarChartResults from './components/bar-chart-results';

import PostTaskQuestions from './components/post-task-questions';

import { GET_ANALYTICS_TREE_TEST_TASK_SUCCESS } from '../../graphql';

const TaskSuccess = (props) => {
  const { projectId, segmentId, projectTestType } = props;
  const [selectedTask, setSelectedTask] = useState(null);

  const {
    loading,
    data = {},
    errors,
  } = useQuery(GET_ANALYTICS_TREE_TEST_TASK_SUCCESS, {
    variables: { projectId, segmentId },
    fetchPolicy: 'no-cache',
  });

  const options = useMemo(() => {
    if (_.isEmpty(data)) return [];

    return data.analytics?.treeTestTaskSuccess?.map((question, index) => ({
      key: question?.id,
      value: question?.id,
      text: `Task ${index + 1}`,
    })) || [];
  }, [data]);

  useEffect(() => {
    if (options.length > 0) {
      setSelectedTask(data.analytics.treeTestTaskSuccess[0]);
    }
  }, [options, data]);

  const handleChangeTask = (e, { value }) => {
    const questions = data?.analytics?.treeTestTaskSuccess || [];

    const currentTask = _.find(questions, (question) => question?.id === value);
    setSelectedTask(currentTask);
  };

  if (loading) {
    return <Loader data-loader="task-success-loader" />;
  }

  if (errors) {
    return <Message>Error while fetching analytics.</Message>;
  }

  if (!selectedTask) return null;

  return (
    <Container>
      <ContainerHeader>
        <Header>Task Success</Header>
        <ContainerDropwdown>
          <Dropdown
            value={selectedTask.id}
            fluid
            selection
            onChange={handleChangeTask}
            options={options}
          />
          <Text>{selectedTask.label}</Text>
        </ContainerDropwdown>
        <ContainerPath>
          {selectedTask.correctPath.map((path) => (
            <Text key={v4()}>{path}</Text>
          ))}
        </ContainerPath>
      </ContainerHeader>
      <BarChartResults
        selectedTask={selectedTask}
      />
      <Divider />
      <PostTaskQuestions
        selectedTask={selectedTask}
        projectTestType={projectTestType}
      />
    </Container>
  );
};

TaskSuccess.propTypes = {
  projectId: string.isRequired,
  segmentId: string,
  projectTestType: string.isRequired,
};

TaskSuccess.defaultProps = {
  segmentId: undefined,
};

export default TaskSuccess;
